import { InjectionToken } from '@angular/core';
import { TrackingConfig } from './tracking-config.model';

export const TRACKING_CONFIG = new InjectionToken<TrackingConfig>('tracking.config');
